<template>
  <hr />
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
hr {
  border-top: 1px solid #a3b8c0;
  background: none;
  margin-bottom: 1em;
  margin-top: 1em;
}
</style>
